import React from "react";
import {AccountInfo, PublicClientApplication} from "@azure/msal-browser";
import {connect} from "react-redux";
import {IRootState} from "../store";
import CDBNav from "./CDBNav";
import {CDBMain} from "./CDBMain";
import LoadingCard from "./LoadingCard";
import { History } from "history";
import {UserAccessLevel} from "../models/UserAccessRecord";

interface HandleMsalRedirectProps
{
    msalInstance: PublicClientApplication;
    userIsCdbEmployee: boolean;
    history: History;
    user: AccountInfo | undefined;
    usersCdbAccessLevel: UserAccessLevel | undefined;
}

interface HandleMsalRedirectState
{
    finishedHandlingRedirect: boolean;
}

class HandleMsalRedirect extends React.Component<HandleMsalRedirectProps,HandleMsalRedirectState> {
    constructor(props: HandleMsalRedirectProps) {
        super(props);
        
        this.state = 
        {
            finishedHandlingRedirect: false 
        };
    }
    
    componentDidMount() {
        
        this.props.msalInstance.handleRedirectPromise().then((r) => {
            this.setState({finishedHandlingRedirect: true});
            return r;
        })
    }
    
    render() {
        if(this.state.finishedHandlingRedirect)
        {
            return this.props.children;
        }
        else
        {
            return (
                <div className={"cdb-admin"}>
                    <div className={"cdb-admin-school-selector"}></div>
                    <CDBNav user={this.props.user} usersCdbAccessLevel={this.props.usersCdbAccessLevel} userIsCdbEmployee={this.props.userIsCdbEmployee} schoolsCanAccess={undefined} history={this.props.history} signOut={() =>{}}/>
                    <CDBMain>
                        <LoadingCard text={"Signing in"}/>
                    </CDBMain>
                </div>
            )
        }
    }
}

export default connect(
    (state: IRootState): HandleMsalRedirectProps => {
        return {
            user: state.auth.user,
            userIsCdbEmployee: state.auth.userIsCdbEmployee,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel,
            history: state.history,
            msalInstance: state.auth.msalInstance
        };
    }
)(HandleMsalRedirect);